export default {
  emailOrPhone: 'Email or phone',
  password: 'Password',
  rememberMe: 'Remember me',
  forgotYourPassword: '¿Forgot your password?',
  signIn: 'Sign in',
  newHere: '¿New Here?',
  openAccount: 'Open an account',
  haveAccount: '¿Already have an account?',
  fullName: 'Full Name',
  country: 'Country', // Possible general translation
  phone: 'Phone',
  email: 'Email',
  iAgree: 'I agree to the',
  termsAndConditions: 'Terms and conditions agreement',
  signUp: 'Sign up',
  recoverPassword: 'Recover your password',
  recover: 'Recover',
  goBack: 'Go back',
  weHaveSentYouACode: 'We have sent you a code to your',
  receivedCode: 'Received code',
  newPassword: 'New password',
  confirmNewPassword: 'Confirm your new password',
  passwordSuccessfullyChanged: 'Password successfully changed'
}
